import type React from 'react'
import { forwardRef } from 'react'
import { Input, type InputProps } from '@chakra-ui/react'
import { withFormLabel } from '../../hocs/withFormLabel'
import { withFormValidation } from '../../hocs/withFormValidation'
import { withPlaceholder } from '../../hocs/withPlaceholder'

/** Teléfono formato Perú: dígitos con un `+` opcional al inicio (código de país). */
function sanitizePhoneValue(raw: string): string {
  if (!raw) return ''
  const hasLeadingPlus = raw.trimStart().startsWith('+')
  const digits = raw.replace(/\D/g, '')
  return (hasLeadingPlus ? '+' : '') + digits
}

/**
 * Input base de teléfono: filtra en vivo a dígitos (+ código de país opcional) y
 * fuerza el teclado numérico en móvil. Sanitiza el valor del evento antes de
 * propagarlo, de modo que react-hook-form recibe el valor ya limpio.
 */
const PhoneInputBase = forwardRef<HTMLInputElement, InputProps>(function PhoneInputBase(
  { onChange, ...props },
  ref,
) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.target.value = sanitizePhoneValue(e.target.value)
    onChange?.(e)
  }
  return <Input ref={ref} inputMode="tel" autoComplete="tel" {...props} onChange={handleChange} />
})

const PlaceholderPhoneInput = withPlaceholder(PhoneInputBase)
export const LabeledPhoneInput = withFormLabel(PlaceholderPhoneInput)
export const TrackedPhoneInput = withFormValidation(LabeledPhoneInput)
